// store.ts
import { useStorage, useDateFormat, createGlobalState } from '@vueuse/core';
import {
  shallowRef,
  computed,
  readonly,
  reactive,
  ref,
  shallowReactive,
  shallowReadonly,
} from 'vue';
import { UAParser } from 'ua-parser-js';
const parser = new UAParser();
import { useCookies } from '@vueuse/integrations/useCookies';
const lazy_image = useStorage('supportLazyImage', '');
// 判断是否支持懒加载
if (!lazy_image.value) {
  let testImg = document.createElement('img');
  if ('loading' in testImg) {
    lazy_image.value = 'true';
  } else {
    lazy_image.value = 'false';
  }
}

// 每次活动都会用到的状态
export const useStore = createGlobalState(() => {
  const count = shallowRef(0);
  const double_count = computed(() => {
    return count.value * 2;
  });
  function set_count(v) {
    count.value = v;
  }

  // 渠道标识
  const channel = shallowReactive({
    utm_source: 'gw',
    extra: 'gw',
    channel: 'h5',
  });
  function set_utm_source(v) {
    channel.utm_source = v;
  }

  function set_extra(v) {
    channel.extra = v;
  }

  function set_channel(v) {
    channel.channel = v;
  }

  // 小程序token
  const mini_token = shallowRef('');
  function set_mini_token(v) {
    mini_token.value = v;
  }

  //   端游扫码登录
  const scan_token = shallowRef('');
  function set_scan_token(v) {
    scan_token.value = v;
  }

  const share_id = ref('');
  function set_share_id(v) {
    share_id.value = v;
  }
  const invite_id = ref('');
  function set_invite_id(v) {
    invite_id.value = v;
  }

  // 浏览器设备信息
  const uaResult = parser.getResult();
  const ua_info = {
    browser: {
      name: uaResult.browser.name,
      version: uaResult.browser.version,
      major: uaResult.browser.major,
    },
    os: {
      name: uaResult.os.name,
      version: uaResult.os.version,
    },
    device: {
      model: uaResult.device.model,
      type: uaResult.device.type, // 'mobile', 'tablet', 'desktop', 'tv', etc.
      vendor: uaResult.device.vendor,
    },
    engine: {
      name: uaResult.engine.name,
      version: uaResult.engine.version,
    },
    cpu: {
      architecture: uaResult.cpu.architecture,
    },
    userAgent: navigator.userAgent,
  };

  const is_mobile = computed(() => {
    return uaResult.device.type === 'mobile' ? true : false;
  });

  const browser = shallowRef(parser.getBrowser().name);
  // 是否支持图片懒加载
  const support_lazy_image = shallowRef(lazy_image.value);

  // 支持的图片格式
  const support_image = useStorage('supportImg', 'png');

  // 活动配置表
  const activity_config = ref({});
  function set_activity_config(v) {
    activity_config.value = v;
  }

  const reveiveDataFormat = computed(() => {
    return useDateFormat(activity_config.value.receive_redpacket_start_time_ms || 0, 'MM月DD日 HH:mm').value
  })
  const reveiveDataFormat2 = computed(() => {
    return useDateFormat(activity_config.value.receive_redpacket_start_time_ms || 0, 'MM.DD').value
  })
  const canReveive = computed(() => {
    if (!activity_config.value.receive_redpacket_start_time_ms) {
      return false
    }
    return new Date().getTime() >= activity_config.value.receive_redpacket_start_time_ms
  })
  return {
    count: readonly(count),
    double_count,
    share_id,
    set_count,
    channel: readonly(channel),
    ua_info,
    support_lazy_image: shallowReadonly(support_lazy_image),
    set_utm_source,
    set_extra,
    set_channel,
    set_mini_token,
    set_share_id,
    set_scan_token,
    scan_token: shallowReadonly(scan_token),
    mini_token: shallowReadonly(mini_token),
    browser: shallowReadonly(browser),
    is_mobile: readonly(is_mobile),
    support_image: readonly(support_image),
    activity_config: readonly(activity_config),
    set_activity_config,
    invite_id,
    set_invite_id,
    reveiveDataFormat,
    reveiveDataFormat2,
    canReveive,
  };
});

// 单次活动需要定义的全局变量:这里是每次都变的
export const useData = createGlobalState(() => {
  const cookies = useCookies(['TXH5_TX3_TXWX_TOKEN']);
  const is_login = computed(() => { // 使用cookie判断是否登录有问题 原因：可能过期
    return cookies.get('TXH5_TX3_TXWX_TOKEN') ? true : false;
  });

  const is_bind = computed(() => {
    return true;
  });
  //   应该是一个根据其他数据算出来的变量
  let init_data = reactive({});
  let table_data = reactive({});
  let team_share_data = ref({});
  let login_status = ref(false);
  let error_codemsg = ref('');
  let copy_link = ref('');

  const member_list = computed(() => {
    return init_data?.act_data?.member_list || [];
  });
  const team_id = computed(() => {
    return init_data?.act_data?.team_id || '';
  });

  function set_init_data(v) {
    Object.assign(init_data, v);
  }
  function set_member_list(v) {
    console.log(init_data);

    init_data.act_data.member_list = v;
  }
  function set_login_status(data) {
    login_status.value = data;
  }
  function set_team_share_data(data) {
    team_share_data.value = data;
  }
  function set_error_codemsg(data) {
    error_codemsg.value = data;
  }
  function set_copy_link(data) {
    copy_link.value = data;
  }
  function set_table_data(data) {
    Object.assign(table_data, data);
  }

  function clear_init_data() {
    for (const key in init_data) {
      delete init_data[key];
    }
  }

  function update_usable_lottery_times(value) {
    init_data.act_data.usable_lottery_times = value;
  }

  const together_id = shallowRef();
  function set_together_id(v) {
    together_id.value = v;
  }

  const item_id=shallowRef()
  
  function set_item_id(v){
    item_id.value=v
  }

  // setTimeout(()=>{
  //   set_together_id('68e9fd7abf7b59be0e4af904')
  // },2000)

  return {
    login_status,
    error_codemsg,
    is_login,
    is_bind,
    init_data: readonly(init_data),
    table_data: readonly(table_data),
    team_share_data,
    member_list,
    team_id,
    set_init_data,
    set_team_share_data,
    clear_init_data,
    set_login_status,
    set_error_codemsg,
    set_table_data,
    set_member_list,
    update_usable_lottery_times,
    copy_link,
    set_copy_link,
    together_id,
    set_together_id,
    set_item_id,
    item_id,
  };
});
